export var Acr;
(function (Acr) {
    Acr["LEGACY"] = "urn:spotify:sso:acr:legacy";
    Acr["BRONZE"] = "urn:spotify:sso:acr:bronze:v1";
    Acr["SILVER"] = "urn:spotify:sso:acr:silver:v1";
    Acr["S4A_2FA"] = "urn:spotify:sso:acr:artist:2fa";
})(Acr || (Acr = {}));
//# sourceMappingURL=index.js.map